import { render, staticRenderFns } from "./MessageFromCEO.vue?vue&type=template&id=107aa1d4&scoped=true"
import script from "./MessageFromCEO.vue?vue&type=script&lang=js"
export * from "./MessageFromCEO.vue?vue&type=script&lang=js"
import style0 from "./MessageFromCEO.vue?vue&type=style&index=0&id=107aa1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.98.0__lodash@4._28343674ad8f8d6f519c68f22b7bf6a1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107aa1d4",
  null
  
)

export default component.exports